import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09dbcb97"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { slot: "dialog-header" }, "Import your data from LinkedIn", -1))
const _hoisted_2 = { slot: "dialog-body" }
const _hoisted_3 = { class: "linkedin-import__header" }
const _hoisted_4 = { class: "linkedin-import__header_step1" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "linkedin-import__header_step2" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "linkedin-import__wrapper" }
const _hoisted_10 = { class: "linkedin-import__wrapper_video" }
const _hoisted_11 = { class: "linkedin-import__wrapper_upload" }
const _hoisted_12 = { slot: "dialog-confirm" }

import {RegisteredDependencies} from '@/profile-creation-wizard/common/DependencyInjection';
    import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';
    import {I18nService} from '@malt/vue3-i18n';
    import {inject, onMounted, reactive, ref, watch} from 'vue';
    import {bool} from 'vue-types';

    // Injection(s)
    type ComponentState = {
        resume?: File;
    };
    const videoSource = 'https://dam.malt.com/profile/signup/linkedin-resume_EN?vh=dd9c27&func=proxy';
    const videoPosterSource = 'https://dam.malt.com/profile/signup/linkedin-resume-poster_EN';

    // Watchers
    const dropzoneMaxFileSize = 5; // 5Mb
    const dropzoneCtaText = 'Import data';
    const dropzoneDescriptionText = 'Give it to me!';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedinImportDialog',
  props: {
        isOpened: bool().def(false).isRequired,
    },
  emits: ["linkedin-dialog:cancel", "linkedin-dialog:confirm"],
  setup(__props, { emit: emits }) {

const props = __props;

    const profileCompletionRepository = inject(RegisteredDependencies.injectionKeys.profileCompletionRepository);

    // Props
    
    // Emits
    

    // State
    const state = reactive<ComponentState>({});
    // References
    const isImportButtonDisabled = ref(true);
    const isImportButtonLoading = ref(false);
    const refLinkedInImportDialog = ref<HTMLJoyDialogElement>();
    const refVideoPlayer = ref<HTMLVideoElement>();
    const videoPlayerCanPlay = ref(false);

    // Video source: Filerobot profile/signup/linkedin-resume_EN (mp4)
    watch(
        () => state.resume,
        () => {
            isImportButtonDisabled.value = !isFormValid();
        },
    );
    watch(
        () => props.isOpened,
        () => {
            if (props.isOpened === true) {
                refVideoPlayer.value.fastSeek(0);
                refVideoPlayer.value.play();
            } else {
                refVideoPlayer.value.pause();
            }
        },
    );

    onMounted(() => {
        refVideoPlayer.value.load();
    });

    const dropzoneErrorFormatMessage = I18nService.msg('tbd.tbd.tbd.error.format');
    const dropzoneErrorMaxSizeMessage = I18nService.msg('tbd.tbd.tbd.error.maxsize');

    function isFormValid(): boolean {
        return !!state.resume;
    }

    async function save(): Promise<boolean> {
        let fileUploaded = false;

        if (isFormValid()) {
            isImportButtonLoading.value = true;

            try {
                await profileCompletionRepository!.importResumeFromLinkedIn(state.resume!);
                fileUploaded = true;
            } catch (e) {
                pushNotification(I18nService.msg('profile.creation.common.notification.error.technical'), {level: 'error'});
            } finally {
                isImportButtonLoading.value = false;
            }
        }

        return fileUploaded;
    }

    // Dialog event handlers
    function handleDialogCancel(): void {
        state.resume = undefined;

        emits('linkedin-dialog:cancel');
    }
    async function handleConfirmDialog() {
        const fileUploaded = await save();

        if (fileUploaded === true) {
            emits('linkedin-dialog:confirm');
        }
    }
    // Dropzone event handlers
    function handleDropzoneDroppedFiles(event: CustomEvent<File[] | null>): void {
        const files = event.detail!;
        if (files.length === 1) {
            state.resume = files[0]!;
        }
    }
    function handleDropzoneRemoveFile(): void {
        if (state.resume) {
            delete state.resume;
        }
    }
    // Video player event handlers
    function handleVideoPlayerEvent(): void {
        videoPlayerCanPlay.value = true;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_dropzone = _resolveComponent("joy-dropzone")!
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_openBlock(), _createBlock(_component_joy_dialog, {
    id: "linkedin-import",
    ref_key: "refLinkedInImportDialog",
    ref: refLinkedInImportDialog,
    size: "large",
    "cancel-text": "Cancel",
    open: props.isOpened,
    onJoyCancelDialog: handleDialogCancel,
    onJoyConfirmDialog: handleConfirmDialog
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(" 1. "),
            _createElementVNode("span", {
              innerHTML: _ctx.$msg('profile.creation.completion.wizard.resume.linkedin.step1.line1')
            }, null, 8, _hoisted_5),
            _createElementVNode("span", {
              innerHTML: _ctx.$msg('profile.creation.completion.wizard.resume.linkedin.step1.line2')
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(" 2. "),
            _createElementVNode("span", {
              innerHTML: _ctx.$msg('profile.creation.completion.wizard.resume.linkedin.step2.line1')
            }, null, 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("video", {
              ref_key: "refVideoPlayer",
              ref: refVideoPlayer,
              width: "430",
              poster: videoPosterSource,
              style: {"background-color":"#fff"},
              onCanplay: handleVideoPlayerEvent
            }, [
              _createElementVNode("source", {
                src: videoSource,
                type: "video/mp4"
              })
            ], 544), [
              [_vShow, videoPlayerCanPlay.value]
            ]),
            (!videoPlayerCanPlay.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: videoPosterSource,
                  class: "fallback-poster"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_joy_dropzone, {
              accept: "application/pdf",
              name: "linkedin-file",
              "id-dropzone": "linkedin-file",
              multiple: "false",
              "data-testid": "linkedin-import-dropzone",
              "max-size": dropzoneMaxFileSize,
              "error-text-format": _unref(dropzoneErrorFormatMessage),
              "error-text-max-size": _unref(dropzoneErrorMaxSizeMessage),
              "button-text": dropzoneCtaText,
              "description-text": "",
              "description-strong-text": dropzoneDescriptionText,
              onJoyDropzoneDroppedFiles: handleDropzoneDroppedFiles,
              onJoyDropzoneRemoveFile: handleDropzoneRemoveFile
            }, null, 8, ["error-text-format", "error-text-max-size"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_joy_button, {
          variant: "main",
          disabled: isImportButtonDisabled.value,
          loading: isImportButtonLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Import data")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})